import { Text } from '@wix/design-system';
import React from 'react';
import { BiCtaNames, BiModalTypes } from '../../bi/types';
import { getEditorCapabilitiesForHost } from '../../utils/editor-host-to-editor-type';
import { buildStudioDialogProps } from './build-studio-dialog-props';
export const getShouldVerifyItemTypeModalProps = (t, editorHost, itemType) => {
  const {
    usesClassicModalChrome
  } = getEditorCapabilitiesForHost(editorHost);
  return {
    content: usesClassicModalChrome ? t('accessibility-wizard.should-verify-item-type-modal.content') : /*#__PURE__*/React.createElement(Text, null, t('accessibility-wizard.should-verify-item-type-modal.content')),
    primaryButtonText: t('accessibility-wizard.should-verify-item-type-modal.primary-button'),
    secondaryButtonText: t('accessibility-wizard.should-verify-item-type-modal.secondary-button'),
    skin: 'standard',
    title: t(`accessibility-wizard.should-verify-item-type-modal.title.${itemType}`)
  };
};
export const showShouldVerifyItemTypeModal = async _ref => {
  let {
    biLogger,
    handleSkipScan,
    a11yWizardAdapter,
    t,
    handleScan,
    editorHost,
    itemType
  } = _ref;
  const {
    usesClassicModalChrome
  } = getEditorCapabilitiesForHost(editorHost);
  const modalProps = {
    ...getShouldVerifyItemTypeModalProps(t, editorHost, itemType),
    primaryButtonOnClick: () => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.ScanPages,
        modalType: BiModalTypes.ScanItemTypeVerification
      });
      handleScan();
    },
    secondaryButtonOnClick: () => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.SkipScan,
        modalType: BiModalTypes.ScanItemTypeVerification
      });
      handleSkipScan();
    }
  };
  biLogger.modalView({
    modalType: BiModalTypes.ScanItemTypeVerification
  });
  if (usesClassicModalChrome) {
    await a11yWizardAdapter.showDialog({
      ...modalProps,
      theme: modalProps.skin
    });
    return;
  }
  await a11yWizardAdapter.showDialog(...buildStudioDialogProps(modalProps));
};
//# sourceMappingURL=show-should-verify-item-type-modal.js.map